import React from "react";

import RichText from "@src/components/elements/RichText";
import { getContentfulPreviewPropsFn } from "@src/utils";
import CaretRight from "@svg/icons/caret-right-colorful.svg";
import clsx from "clsx";

import { getImageSrc } from "./Card.utils";

const NewCard = ({ contentful_id, image, headline, body, cta }) => {
  const getPreviewCardProps = getContentfulPreviewPropsFn(contentful_id);

  return (
    <div className={clsx(`border border-base font-bold rounded-lg p-5 sm:p-4 md:p-3 max-w-[300px] sm:max-w-[250px]`)}>
      {(image?.url || image?.file?.url) && (
        <img
          alt={image?.description || ""}
          className="mb-3"
          height={32}
          src={getImageSrc(image?.url ?? image.file.url, 32)}
          width={32}
        />
      )}
      {headline && (
        <h4
          className={clsx("text-xl mb-3")}
          {...getPreviewCardProps("headline")}
        >
          {headline}
        </h4>
      )}
      <div {...getPreviewCardProps("body")}>
        <RichText
          bodyRichText={
            !body?.json ? body : { raw: JSON.stringify(body?.json) }
          }
          classes={clsx("space-y-4")}
          useHeadings
        />
      </div>

      {cta?.at(0) && (
        <div className="mt-4">
          {cta.map(({ id, label, url }) => (
            <a key={id} className="btn-new btn-new--small" href={url}>
              {label}
              <CaretRight height={16} width={16} />
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default NewCard;
